import { render, staticRenderFns } from "./ModalCategory.vue?vue&type=template&id=21367a87&scoped=true&"
import script from "./ModalCategory.vue?vue&type=script&lang=js&"
export * from "./ModalCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21367a87",
  null
  
)

export default component.exports